<!-- <div class="list-item-item row list-item"
[ngClass]="{ 'list-item--opened': openedItems[index], 'list-item--ready': statement.isReady() }">
<div class="list-item__row columns is-mobile">
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Id</div>
    <div class="list-item__col-value">{{ statement.id }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Date</div>
    <div class="list-item__col-value">{{ statement.createdDate }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Name</div>
    <div class="list-item__col-value">{{ statement.firstName }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Surname</div>
    <div class="list-item__col-value">{{ statement.lastName }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Steurer No.</div>
    <div class="list-item__col-value">{{ statement.steuernummer }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>DOB</div>
    <div class="list-item__col-value">{{ statement.birthDate }}</div>
  </div>
</div>
<div class="list-item__row columns is-mobile">
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Tax Year</div>
    <div class="list-item__col-value">{{ statement.fullYear }}</div>
  </div>
  <div class="list-item__col column row__column">
    <div class="list-item__col-title" i18n>Status</div>
    <div class="list-item__col-value">{{ statement.statusText }}</div>
  </div>
  <div class="list-item__col list-item__col--refund column row__column">
    <div class="list-item__col-title" i18n>Refund/Tax (€)</div>
    <div class="list-item__col-value row__refund-column">
      <span class="row__refund-value">{{ getRefund() }}</span>
      <span class="icon is-small row__refund-icon" (click)="openRefundDetailsDialog()">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
    </div>
  </div>
  <div class="list-item__col column row__column row__actions-column">
    <div class="list-item__col-title" i18n>Actions</div>
    <div class="list-item__col-value">
      <button class="btn btn--info btn--icon btn--small" title="Edit" i18n-title="Edit"
        (click)="editStatement()" [disabled]="statement.isProcessing()"
        *ngIf="!hideEditing && !statement.isSent() && statement.employers && statement.employers.length > 0">
        <span class="icon is-small">
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </span>
      </button>

      <button class="btn btn--info btn--icon btn--small" title="Download PDF" i18n-title="Download PDF"
        [class.is-loading]="statement.downloadingPdf" [disabled]="statement.downloadingPdf"
        *ngIf="!hidePdf && statement.canDownloadPdf" (click)="emitDownloadPdf()">
        <span class="icon is-small">
          <i class="fa fa-download" aria-hidden="true"></i>
        </span>
      </button>

      <button class="btn btn--info btn--icon btn--small" title="DownloadInvoice" i18n-title="DownloadInvoice"
        [class.is-loading]="statement.downloadingInvoice" [disabled]="statement.downloadingInvoice"
        *ngIf="!hideInvoice && statement.isPaid" (click)="emitDownloadInvoice()">
        <span class="icon is-small">
          <i class="fa fa-euro" aria-hidden="true"></i>
        </span>
      </button>

      <button class="btn btn--info btn--icon btn--small" title="Attach Ewr" i18n-title="Attach Ewr"
        *ngIf="!statement.isSent() && statement.batchCode || !statement.isSent() && statement.serviceType==='tax_adviser'" (click)="uploadEWRAttatchment()">
        <span class="icon is-small">
          <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
        </span>
      </button>

      <button class="btn btn--info btn--icon btn--small" title="Delete statement"
        i18n-title="Delete statement" [class.is-loading]="statement.deleting"
        [disabled]="statement.deleting"
        *ngIf="!(statement.isProcessing() || statement.isSent() || statement.isPaid || hideRemoving)"
        (click)="emitDeleteStatement()">
        <span class="icon is-small">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </span>
      </button>

      <button class="btn btn--info btn--icon btn--small" title="Show decision" i18n-title="Show decision"
        *ngIf="!hideDecision && statement.isSent() && statement.canDownloadDecision"
        (click)="emitShowDecision()">
        <span class="icon is-small">
          <i class="fa fa-institution" aria-hidden="true"></i>
        </span>
      </button>
      <ng-container *ngIf="showEditButton">
        <button class="btn btn--info btn--icon btn--small" (click)="emitImportStatement()" title="{{'CARD.IMPORT_STATEMENT' | translate}}">
          <span class="icon is-small">
            <i class="fa fa-file-o" aria-hidden="true"></i>
          </span>
        </button>
      </ng-container>
      <button class="btn btn--info btn--icon btn--small" (click)="emitCloneStatement()" title="{{'CARD.CLONE_STATEMENT' | translate}}">
        <span class="icon is-small">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </span>
      </button>
      <button class="btn btn--xsmall btn--info"
        *ngIf="showEditButton && !statement.isSent() && !statement.isPaid"
      (click)="emitOnEditButton()">{{ 'COMMON.EDIT' | translate }}</button>
    </div>
  </div>
  <div class="list-item__col column row__column row__actions-column">
    <app-labels-edit-batches [(statement)]="statement" [(labelList)]="labelList"
    *ngIf="labelList.length>0 && statement"></app-labels-edit-batches>
  </div>
</div>
</div> -->

<div
  class="list-item-item row list-item"
  [ngClass]="{ 'list-item--opened': openedItems[index], 'list-item--ready': statement.isReady() }"
  >
  <div class="list-item__col column row__column tax_year">
    <div class="list-item__col-title" i18n>Tax Year</div>
    <div class="list-item__col-value"
      ><b>{{ statement.fullYear }}</b></div
      >
    </div>

    <div class="list-item__col column row__column name">
      <div class="list-item__col-title" i18n>Name</div>
      <div class="list-item__col-value">{{ statement.firstName }}</div>
    </div>

    <div class="list-item__col column row__column surname">
      <div class="list-item__col-title" i18n>Surname</div>
      <div class="list-item__col-value">{{ statement.lastName }}</div>
    </div>

    <div class="list-item__col column row__column id">
      <div class="list-item__col-title" i18n>Id</div>
      <div class="list-item__col-value">{{ statement.id }}</div>
    </div>

    <div class="list-item__col column row__column date">
      <div class="list-item__col-title" i18n>Date</div>
      <div class="list-item__col-value">{{ statement.createdDate }}</div>
    </div>

    <div class="list-item__col column row__column progress_col">
      <div class="list-item__col-title" i18n>Progress</div>
      <div class="list-item__col-value">{{ getDashboardFinishPrecent() }}%</div>
    </div>

    <div class="list-item__col list-item__col--refund column row__column refund_tax" (click)="openRefundDetailsDialog()">
      <div class="list-item__col-title" i18n>Refund/Tax</div>
      <div class="list-item__col-value row__refund-column">
        <span
          class="row__refund-value"
          [class.red]="statement.estimatedRefund < 0"
          [class.green]="statement.estimatedRefund > 0"
        [class.grey]="
          statement.serviceType === 'tax_adviser' && (statement.status === 'paid' || statement.status === 'paid_ready')
        "
          >
          <b [id]="'statement_refund_tax_' + statement.id">{{ getRefund() }}</b>
        </span>
        <!-- <span class="icon is-small row__refund-icon" >
        <i class="fa fa-search" aria-hidden="true"></i>
      </span> -->
    </div>
  </div>

  <div class="list-item__col column row__column steuer_no is-mobile">
    <div class="list-item__col-title" i18n>Steurer No.</div>
    <div class="list-item__col-value">
      @if (statement.steuernummer) {
        {{ statement.steuernummer }}
      }
      @if (!statement.steuernummer) {
        -
      }
    </div>
  </div>

  <div class="list-item__col column row__column cost is-mobile">
    <div class="list-item__col-title" i18n>Cost</div>
    <div class="list-item__col-value">{{ getPayment() }}</div>
  </div>

  <div #statusItem class="list-item__col column row__column status is-mobile">
    <div class="list-item__col-title" i18n>Status</div>
    <div class="list-item__col-value">
      <b>{{ getDashboardStatus() | translate }}</b>
    </div>
    @if (statement.dashboardStatus === 'ORDERED') {
      <app-more-info-tooltip
        [isXSmallIcon]="true"
        [message]="'TOOLTIP.DASHBOARD_ORDERED'"
        [showText]="false"
      ></app-more-info-tooltip>
    }
    @if (statement.dashboardStatus === 'IN_APPROVAL') {
      <app-more-info-tooltip
        [isXSmallIcon]="true"
        [message]="'TOOLTIP.DASHBOARD_IN_APPROVAL'"
        [showText]="false"
      ></app-more-info-tooltip>
    }
    @if (statement.dashboardStatus === 'SUBMITED') {
      @if (statement.hasCertificate) {
        <app-more-info-tooltip
          [isXSmallIcon]="true"
          [message]="'TOOLTIP.DASHBOARD_SUBMITTED_CERTIFICATE'"
          [showText]="false"
        ></app-more-info-tooltip>
      }
      @if (!statement.hasCertificate) {
        <app-more-info-tooltip
          [isXSmallIcon]="true"
          [message]="'TOOLTIP.DASHBOARD_SUBMITTED_NO_CERTIFICATE'"
          [showText]="false"
        ></app-more-info-tooltip>
      }
    }
  </div>

  <!-- <div
  class="list-item__col column row__column attachments"
    *ngIf="
      (!statement.isSent() && statement.batchCode) || (!statement.isSent() && statement.serviceType === 'tax_adviser')
    "
  >
  <div class="list-item__col-title" i18n>Attachments</div>
  <div class="list-item__col-value">
    <button
      type="button"
      class="btn_att"
      (click)="showAttachments()"
      [id]="'statement_show_attachments_' + statement.id"
      >
      <span>{{ statement.numberOfAttachments }}</span>
      <img src="assets/svg/attachments.svg" />
    </button>
  </div>
</div> -->

<div class="list-item__col column row__column row__actions-column actions list-item__col_end is-mobile">
  <div class="list-item__col-title" i18n>Actions</div>
  <div class="list-item__col-value">
    @if (statement.hasOpenDocumentRequest && statement.isPremiumPackage && !isTaxAdviser && !isBusiness) {
      <button
        class="btn btn--info btn--icon btn--small"
        title="{{ 'DOCUMENT_REQUEST.TILE_BUTTON' | translate }}"
        (click)="openDocumentRequestDialog()"
      >
        <span class="icon is-small">
          <i class="fa fa-upload" aria-hidden="true"></i>
        </span>
      </button>
    }
    @if (!hideEditing && !statement.isSent() && statement.employers && statement.employers.length > 0) {
      <button
        class="btn btn--info btn--icon btn--small"
        title="Edit"
        i18n-title="Edit"
        (click)="editStatement()"
        [disabled]="statement.isProcessing()"
        [id]="'statement_edit_' + statement.id"
        >
        <img src="../../../assets/svg/edit_icon.svg" class="edit_icon" alt="Edit" />
      </button>
    }

    @if (displayDownloadsButton() && statement.numberOfAttachments > 0) {
      <button
        class="btn_icon downloads"
        mat-button
        title="Downloads"
        i18n-title="Downloads"
        (click)="emitShowDownloadDialog()"
        >
        <span>{{ statement.numberOfAttachments }}</span>
        <img src="../../../assets/svg/download.svg" alt="download" />
      </button>
    }

    @if (shouldShowRabeDocumentsBadge) {
      <button
        type="button"
        class="btn_att btn_att--rabe"
        [id]="'statement_rabe_attachments_' + statement.id"
        [title]="'LIST.TOOLTIPS.ATTACHMENTS_RABE' | translate"
        (click)="openRabeDialogFromCloudBadge()"
      >
        <span>{{ rabeAttachmentsCount }}</span>
        <i class="fa fa-cloud rabe-cloud-icon" aria-hidden="true"></i>
      </button>
    }

    @if (!hideInvoice && statement.isPaid) {
      <button
        class="btn btn--info btn--icon btn--small"
        title="DownloadInvoice"
        i18n-title="DownloadInvoice"
        [class.is-loading]="statement.downloadingInvoice"
        [disabled]="statement.downloadingInvoice"
        (click)="emitDownloadInvoice()"
        >
        <span class="icon is-small">
          <i class="fa fa-euro" aria-hidden="true"></i>
        </span>
      </button>
    }

    @if (!hideDecision && statement.isSent() && statement.canDownloadDecision) {
      <button
        class="btn btn--info btn--icon btn--small"
        title="Show decision"
        i18n-title="Show decision"
        (click)="emitShowDecision()"
        >
        <span class="icon is-small">
          <i class="fa fa-institution" aria-hidden="true"></i>
        </span>
      </button>
    }

    @if (showEditButton) {
      <button
        class="btn btn--info btn--icon btn--small"
        (click)="emitImportStatement()"
        title="{{ 'CARD.IMPORT_STATEMENT' | translate }}"
        >
        <span class="icon is-small">
          <i class="fa fa-file-o" aria-hidden="true"></i>
        </span>
      </button>
    }

    @if (statement.isSent()) {
      <button
        [id]="cloneStatement.observers && cloneStatement.observers.length ? '' : 'btn-clone-' + statement.id"
        class="btn btn--info btn--icon btn--small"
        (click)="emitCloneStatement()"
        title="{{ 'CARD.CLONE_STATEMENT' | translate }}"
        >
        <img src="../../../assets/svg/duplicate.svg" class="clone_icon" alt="Clone" />
      </button>
    }

    @if (!(statement.isProcessing() || statement.isSent() || statement.isPaid || hideRemoving)) {
      <button
        class="btn btn--info btn--icon btn--small"
        title="Delete statement"
        i18n-title="Delete statement"
        [class.is-loading]="statement.deleting"
        [disabled]="statement.deleting"
        (click)="emitDeleteStatement()"
        >
        <img src="../../../assets/svg/del_icon.svg" class="delete_icon" alt="Delete" />
      </button>
    }

    @if (showEditButton && !statement.isSent() && !statement.isPaid) {
      <button
        class="btn btn--xsmall btn--info"
        [attr.data-cy]="'btnEditStatementB2B'"
        (click)="emitOnEditButton()"
        [id]="'statement_edit_' + statement.id"
        >
        {{ "COMMON.EDIT" | translate }}
      </button>
    }
  </div>
</div>
<div class="list-item__col column row__column row__actions-column hamburger list-item__col_end is-mobile">
  <div class="list-item__col-title" i18n></div>
  @if (shouldShowHamburgerMenu) {
    <app-mini-hamburger-menu [template]="hamburgerElements"></app-mini-hamburger-menu>
  }
</div>
</div>

<ng-template #hamburgerElements>
  @if (displayMessageButtons()) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openAppealDecisionDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_APPEAL" | translate }}</span>
    </button>
  }
  @if (displayMessageButtons()) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSendNewMessageDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_MESSAGE" | translate }}</span>
    </button>
  }
  @if (displayMessageButtons() && !isTaxAdviser) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSendAttachmentDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_ATTACHMENT" | translate }}</span>
    </button>
  }
  @if (displayLegacyEwrButton()) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSaveEwrDialogComponent()"
    >
      <span i18n>{{ "COMMON.ATTACH_EWR" | translate }}</span>
    </button>
  }
  @if (displayRabeButton()) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSendRabeDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_RABE" | translate }}</span>
    </button>
  }
  @if (displayMessageBellege()) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSendBellegeDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_BELLEGE" | translate }}</span>
    </button>
  }
  @if (isMasterAccount || isSubAccount) {
    <button
      class="btn_icon hamburger-button"
      mat-button
      [class.is-loading]="statement.deleting"
      [disabled]="statement.deleting"
      (click)="openSendVollmachtDialogComponent()"
    >
      <span i18n>{{ "COMMON.SEND_VOLMACHT" | translate }}</span>
    </button>
  }
</ng-template>
